/* ===========================================================================
   ultra.js — landing del UnoKeeper Ultra 2026.
   - Compra: /cart/add.js con los datos del participante como line item
     properties y directo al checkout (si fetch falla, el <form> nativo sigue vivo).
   - Código de acceso: UK26-XXXX-XXXX aleatorio (crypto), viaja en el pedido como
     propiedad «Código de acceso». Se guarda en este navegador para mostrar el QR.
   - Tu acceso: dibuja el QR (lib qrcode-generator, MIT, cargada al vuelo desde
     los assets del tema) y consulta al escáner si el pago ya está confirmado.
   Contrato de datos compartido con el escáner: proyectos/ultra-2026/accesos/README.md
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var root = D.querySelector('[data-ux]');
  if (!root) return;

  var $ = function (s, c) { return (c || D).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var pad2 = function (n) { return String(n).padStart(2, '0'); };

  var LS_KEY = 'uk-ultra26-accesos';
  var ALPHA = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ'; // 32 símbolos, sin 0/1/I/O
  var ACCESS_BASE = (root.getAttribute('data-access-base') || '').replace(/\/+$/, '');
  var PRODUCT_ID = Number(root.getAttribute('data-product-id') || 0);
  var EVENT_LINE = 'Sábado 12 de diciembre · 15:00 h';
  var VENUE_LINE = 'Instituto Oviedo · León, Gto.';

  /* ------------------------------ Utilidades ------------------------------ */
  var store = {
    get: function () {
      try {
        var v = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
        return Array.isArray(v) ? v.filter(function (a) { return a && normCode(a.code); }) : [];
      } catch (e) { return []; }
    },
    set: function (list) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(list.slice(-12))); } catch (e) { /* modo privado */ }
    },
    upsert: function (entry) {
      var list = store.get().filter(function (a) { return a.code !== entry.code; });
      list.push(entry);
      store.set(list);
    },
    remove: function (code) {
      store.set(store.get().filter(function (a) { return a.code !== code; }));
    }
  };

  function newCode() {
    var b = new Uint8Array(8);
    (window.crypto || window.msCrypto).getRandomValues(b);
    var s = '';
    for (var i = 0; i < 8; i++) s += ALPHA[b[i] & 31]; // 256 % 32 = 0: sin sesgo
    return 'UK26-' + s.slice(0, 4) + '-' + s.slice(4);
  }

  /* Acepta «uk26 7kq4 m2xp», la URL del QR o el código con guiones. */
  function normCode(raw) {
    var m = String(raw || '').toUpperCase().match(/UK26[^0-9A-Z]*([0-9A-Z]{4})[^0-9A-Z]*([0-9A-Z]{4})/);
    if (!m) return null;
    var t = m[1] + m[2];
    for (var k = 0; k < 8; k++) if (ALPHA.indexOf(t[k]) < 0) return null;
    return 'UK26-' + t.slice(0, 4) + '-' + t.slice(4);
  }

  function normName(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  function el(tag, cls, text) {
    var n = D.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  }

  function accessUrl(code) { return ACCESS_BASE + '/c/' + code; }

  /* ------------------------ Header, reveal, sticky ------------------------ */
  function initChrome() {
    window.__uxBoot = 1; // el respaldo del <head> (page.ultra.liquid) no destapa los reveals si esto corrió
    var header = $('[data-ux-header]');
    var onScroll = function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var reveals = $$('.ux-reveal, .ux-stations');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (n) { io.observe(n); });
    } else {
      reveals.forEach(function (n) { n.classList.add('is-in'); });
    }

    /* CTA pegajoso (móvil): aparece pasando el hero y se esconde en la compra. */
    var sticky = $('[data-ux-sticky]');
    var hero = $('#inicio');
    var buy = $('#comprar');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var state = { hero: true, buy: false };
      var paint = function () {
        var show = !state.hero && !state.buy;
        sticky.classList.toggle('is-visible', show);
        D.body.classList.toggle('has-sticky', show);
      };
      new IntersectionObserver(function (e) { state.hero = e[0].isIntersecting; paint(); }, { threshold: 0.05 }).observe(hero);
      if (buy) new IntersectionObserver(function (e) { state.buy = e[0].isIntersecting; paint(); }, { threshold: 0 }).observe(buy);
    }

    /* Links que abren un <details> (aviso de privacidad). */
    $$('[data-open-details]').forEach(function (a) {
      a.addEventListener('click', function () {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var d = id && D.getElementById(id);
        if (d && d.tagName === 'DETAILS') d.open = true;
      });
    });
  }

  /* ------------------------- Preventa y cuenta regresiva ------------------ */
  function initClock() {
    var phaseEnd = new Date(root.getAttribute('data-phase-end') || '');
    var eventStart = new Date(root.getAttribute('data-event-start') || '');
    var clock = $('[data-ux-clock]');
    var strip = clock ? clock.closest('.ux-strip') : null;

    function applyPhase() {
      var inPhase = !isNaN(phaseEnd.getTime()) && Date.now() < phaseEnd.getTime();
      $$('[data-phase-only]').forEach(function (n) { n.hidden = !inPhase; });
      $$('[data-after-phase]').forEach(function (n) { n.hidden = inPhase; });
      return inPhase ? phaseEnd : eventStart;
    }

    var target = applyPhase();
    if (!clock || isNaN(target.getTime())) return;
    var dEl = $('[data-cd-d]', clock), hEl = $('[data-cd-h]', clock), mEl = $('[data-cd-m]', clock), sEl = $('[data-cd-s]', clock);
    var timer;
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        if (target === phaseEnd) { target = applyPhase(); return tick(); }
        if (strip) strip.classList.add('is-past');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      dEl.textContent = Math.floor(s / 86400);
      hEl.textContent = pad2(Math.floor(s / 3600) % 24);
      mEl.textContent = pad2(Math.floor(s / 60) % 60);
      sEl.textContent = pad2(s % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ----------------------------- Video del hero ---------------------------- */
  /* La imagen del key art es el LCP; el video se pide hasta después de `load`, entra
     con fundido al reproducirse y se pausa fuera de pantalla. Con reduced-motion o
     ahorro de datos no se descarga ni un byte. */
  function initHeroVideo() {
    var v = $('[data-ux-video]');
    if (!v) return;
    var btn = $('[data-ux-video-toggle]');
    var conn = navigator.connection || {};
    if (D.documentElement.classList.contains('reduced-motion') || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

    var mobile = window.matchMedia('(max-width: 899px)').matches;
    var pick = function (codec) { return v.getAttribute('data-' + (mobile ? 'm' : 'd') + '-' + codec) || v.getAttribute('data-d-' + codec); };
    var useAv1 = v.canPlayType('video/mp4; codecs="av01.0.05M.08"') === 'probably' && pick('av1');
    var userPaused = false, inView = true;

    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); if (btn) btn.hidden = false; });
    v.addEventListener('error', function () {
      if (useAv1) { useAv1 = false; v.src = pick('h264'); v.load(); play(); return; }
      v.remove(); if (btn) btn.hidden = true;
    }, true);

    function start() {
      v.src = useAv1 ? pick('av1') : pick('h264');
      v.load();
      play();
    }
    if (D.readyState === 'complete') setTimeout(start, 150);
    else window.addEventListener('load', function () { setTimeout(start, 150); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        inView = e[0].isIntersecting;
        if (!inView) v.pause(); else if (!userPaused && v.src) play();
      }, { threshold: 0.05 }).observe(v);
    }
    if (btn) {
      btn.addEventListener('click', function () {
        userPaused = !userPaused;
        btn.setAttribute('aria-pressed', String(userPaused));
        btn.setAttribute('aria-label', userPaused ? 'Reproducir el video de fondo' : 'Pausar el video de fondo');
        if (userPaused) v.pause(); else if (inView) play();
      });
    }
  }

  /* --------------------------------- Videos -------------------------------- */
  function initVideos() {
    $$('[data-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yt');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var f = D.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
        f.title = btn.getAttribute('aria-label') || 'Video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.loading = 'lazy';
        btn.replaceWith(f);
      });
    });
  }

  /* -------------------------- Carrusel de videos --------------------------- */
  /* En escritorio con mouse no hay forma nativa de desplazar una fila horizontal:
     flechas que avanzan una tarjeta, arrastre con el mouse y teclado (← →). El
     touch sigue siendo el scroll nativo. */
  function initCarousel() {
    var row = $('[data-carousel]');
    if (!row) return;
    var nav = $('[data-carousel-nav]');
    var prev = $('[data-carousel-prev]');
    var next = $('[data-carousel-next]');
    var GAP = 16;

    function step() {
      var card = row.firstElementChild;
      return card ? card.getBoundingClientRect().width + GAP : row.clientWidth * 0.8;
    }
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      if (nav) nav.hidden = max < 8;
      if (prev) prev.disabled = row.scrollLeft <= 4;
      if (next) next.disabled = row.scrollLeft >= max - 4;
    }
    function go(dir) { row.scrollBy({ left: dir * step(), behavior: 'smooth' }); }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    row.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
    });

    // Arrastre solo con mouse; si hubo arrastre, el click que suelta no abre el video.
    // El drag nativo de las miniaturas (<img>) cancelaría los pointermove: se apaga.
    var drag = null;
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: row.scrollLeft, moved: false };
    });
    row.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 5) return;
      if (!drag.moved) { drag.moved = true; row.classList.add('is-dragging'); }
      row.scrollLeft = drag.left - dx;
    });
    function endDrag() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      row.classList.remove('is-dragging');
      if (!moved) return;
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); off(); };
      var off = function () { row.removeEventListener('click', swallow, true); };
      row.addEventListener('click', swallow, true);
      setTimeout(off, 60);
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { row.addEventListener(ev, endDrag); });

    $$('img', row).forEach(function (img) { if (!img.complete) img.addEventListener('load', update); });
    update();
  }

  /* ------------------------ Aviso de compra pendiente ----------------------- */
  /* Quien vuelve del checkout sin pagar ya tiene su acceso en el carrito: se le dice y se le
     ofrece retomar el pago, en vez de dejarlo llenar todo otra vez. */
  function initCartNotice() {
    var wrap = $('.ux-formwrap');
    if (!wrap || !PRODUCT_ID || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var n = (cart.items || []).reduce(function (s, it) { return s + (it.product_id === PRODUCT_ID ? it.quantity : 0); }, 0);
        if (!n) return;
        var box = el('div', 'ux-cartnote');
        box.setAttribute('role', 'status');
        box.appendChild(el('span', '', n === 1 ? 'Tienes un acceso en tu carrito sin pagar.' : 'Tienes ' + n + ' accesos en tu carrito sin pagar.'));
        var a = el('a', 'ux-btn ux-btn--grad ux-btn--sm');
        a.href = '/checkout';
        a.appendChild(el('span', '', 'Continuar al pago'));
        box.appendChild(a);
        wrap.insertBefore(box, wrap.firstChild);
      })
      .catch(function () { /* sin aviso */ });
  }

  /* --------------------------------- Compra -------------------------------- */
  function initBuy() {
    var form = $('#ux-buy-form');
    if (!form) return;

    var btn = $('[data-buy-submit]', form);
    var priceOut = $('[data-buy-price]', form);
    var errBox = $('[data-form-error]', form);
    var sizesErr = $('[data-err-sizes]', form);
    var codeInput = $('[data-access-code]', form);
    var nombre = $('#ux-nombre', form);
    var edad = $('#ux-edad', form);
    var wa = $('#ux-wa', form);
    var tutorField = $('[data-tutor-field]', form);
    var tutor = $('#ux-tutor', form);

    function checkedSize() { return $('.ux-size input:checked', form); }

    function refreshPrice() {
      var c = checkedSize();
      if (c && priceOut) priceOut.textContent = fmtMoney(parseInt(c.getAttribute('data-price'), 10));
      if (c && sizesErr) sizesErr.textContent = '';
    }
    $$('.ux-size input', form).forEach(function (r) { r.addEventListener('change', refreshPrice); });
    refreshPrice();

    function isMinor() { var a = parseInt(edad.value, 10); return !isNaN(a) && a < 18; }
    function refreshTutor() {
      var minor = isMinor();
      tutorField.hidden = !minor;
      tutor.required = minor;
      if (!minor) { tutor.value = ''; setErr(tutor, ''); }
    }
    edad.addEventListener('input', refreshTutor);
    refreshTutor();

    /* Al teclear solo se limpian los no-dígitos. El prefijo (52, 521, 044, 045, 01) se quita al
       salir del campo y al validar, y SOLO si quedan exactamente 10 dígitos: antes «+52 1 477 390
       4522» se guardaba como 1477390452 y pasaba la validación (es el canal de la carta responsiva). */
    wa.addEventListener('input', function () {
      var d = wa.value.replace(/\D/g, '').slice(0, 13);
      if (d !== wa.value) wa.value = d;
    });
    function normWa() {
      var d = wa.value.replace(/\D/g, '');
      var m = d.match(/^(?:521|52|044|045|01)(\d{10})$/);
      if (m) d = m[1];
      if (d !== wa.value) wa.value = d;
    }
    wa.addEventListener('blur', normWa);
    wa.addEventListener('change', normWa);

    /* Cada consentimiento enciende un hidden con la constancia fechada que viaja en el pedido. */
    var now = new Date();
    var stamp = now.getFullYear() + '-' + pad2(now.getMonth() + 1) + '-' + pad2(now.getDate()); // fecha local, no UTC
    $$('[data-consent]', form).forEach(function (chk) {
      var hidden = D.getElementById(chk.getAttribute('data-prop'));
      chk.addEventListener('change', function () {
        if (hidden) { hidden.disabled = !chk.checked; hidden.value = chk.checked ? ('Aceptado el ' + stamp) : ''; }
        chk.closest('.ux-check').classList.toggle('is-invalid', false);
      });
    });

    function setErr(input, msg) {
      var field = input.closest('.ux-field');
      if (!field) return;
      field.classList.toggle('is-invalid', !!msg);
      var e = $('[data-err]', field);
      if (e) e.textContent = msg || '';
    }
    [nombre, edad, wa, tutor].forEach(function (i) { i.addEventListener('input', function () { setErr(i, ''); }); });

    function validate() {
      var first = null;
      var mark = function (input, msg) { setErr(input, msg); if (msg && !first) first = input; };
      var n = nombre.value.trim();
      mark(nombre, n.split(/\s+/).length < 2 || n.length < 5 ? 'Escribe nombre y apellido del portero.' : '');
      var a = parseInt(edad.value, 10);
      mark(edad, isNaN(a) || a < 5 || a > 70 ? 'Escribe una edad válida.' : '');
      normWa();
      mark(wa, /^\d{10}$/.test(wa.value) ? '' : 'Escribe 10 dígitos, sin lada internacional.');
      if (isMinor()) mark(tutor, tutor.value.trim().length < 5 ? 'Escribe el nombre del padre, madre o tutor.' : '');
      if (!checkedSize()) { sizesErr.textContent = 'Elige la talla del jersey.'; if (!first) first = sizesErr; }
      $$('[data-consent]', form).forEach(function (chk) {
        var bad = !chk.checked;
        chk.closest('.ux-check').classList.toggle('is-invalid', bad);
        if (bad && !first) first = chk;
      });
      if (first) {
        showError(first.matches && first.matches('[data-consent]') ? 'Marca las tres casillas para poder participar.' : 'Revisa los campos marcados.');
        if (first.focus) first.focus({ preventScroll: true });
        (first.closest('.ux-field, .ux-check, .ux-fs') || first).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.hidden = false;
    }

    function busy(on) {
      btn.disabled = on;
      btn.classList.toggle('is-loading', on);
    }
    /* Al volver del checkout con «Atrás» el navegador restaura la página congelada (bfcache)
       con el botón deshabilitado y girando: se reactiva sin vaciar el formulario. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      busy(false);
      errBox.hidden = true;
    });

    function jsonFetch(url, opts) {
      return fetch(url, opts).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'No se pudo apartar tu lugar. Intenta de nuevo.');
          return body;
        });
      });
    }

    form.addEventListener('submit', function (ev) {
      errBox.hidden = true;
      if (!validate()) { ev.preventDefault(); return; }

      /* Sin fetch: el POST nativo funciona igual, con un código nuevo. */
      if (!window.fetch || !window.FormData) { codeInput.value = newCode(); return; }
      ev.preventDefault();
      busy(true);

      nombre.value = nombre.value.replace(/\s+/g, ' ').trim();
      if (tutor.value) tutor.value = tutor.value.replace(/\s+/g, ' ').trim();
      var who = normName(nombre.value);
      var size = checkedSize();

      /* Si este participante ya estaba en el carrito (volvió atrás desde el checkout),
         se reemplaza su línea y conserva su código: así no se cobra doble. */
      jsonFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (cart) {
          var dupes = (cart.items || []).filter(function (it) {
            return it.product_id === PRODUCT_ID && it.properties && normName(it.properties['Participante']) === who;
          });
          var reuse = dupes.length ? normCode(dupes[0].properties['Código de acceso']) : null;
          codeInput.value = reuse || newCode();
          return dupes.reduce(function (p, it) {
            return p.then(function () {
              return jsonFetch('/cart/change.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: it.key, quantity: 0 })
              });
            });
          }, Promise.resolve());
        })
        .then(function () {
          var fd = new FormData(form);
          fd.delete('return_to');
          /* Opcionales vacíos fuera: el checkout no muestra «Club:» en blanco. */
          ['properties[Club]', 'properties[Tutor]'].forEach(function (k) { if (!String(fd.get(k) || '').trim()) fd.delete(k); });
          return jsonFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd });
        })
        .then(function () {
          store.upsert({
            code: codeInput.value,
            participante: nombre.value.trim(),
            talla: size ? size.getAttribute('data-title') : '',
            ts: Date.now()
          });
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          busy(false);
          var msg = err && err.message;
          showError(msg === 'Failed to fetch' || msg === 'Load failed' ? 'Se cortó la conexión. Intenta de nuevo.' : (msg || 'No se pudo apartar tu lugar.'));
          errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });
  }

  /* ------------------------------- Tu acceso ------------------------------- */
  var qrLib = null;
  function loadQR() {
    if (window.qrcode) return Promise.resolve(window.qrcode);
    if (qrLib) return qrLib;
    qrLib = new Promise(function (resolve, reject) {
      var s = D.createElement('script');
      s.src = root.getAttribute('data-qr-src');
      s.async = true;
      s.onload = function () { window.qrcode ? resolve(window.qrcode) : reject(new Error('qr')); };
      s.onerror = function () { qrLib = null; reject(new Error('qr')); };
      D.head.appendChild(s);
    });
    return qrLib;
  }

  function qrMatrix(lib, text) {
    var qr = lib(0, 'M');
    qr.addData(text);
    qr.make();
    return qr;
  }

  function qrSvg(qr) {
    var n = qr.getModuleCount(), q = 4, size = n + q * 2, d = '';
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (qr.isDark(r, c)) d += 'M' + (c + q) + ' ' + (r + q) + 'h1v1h-1z';
      }
    }
    var NS = 'http://www.w3.org/2000/svg';
    var svg = D.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
    svg.setAttribute('shape-rendering', 'crispEdges');
    svg.setAttribute('aria-hidden', 'true');
    var bg = D.createElementNS(NS, 'rect');
    bg.setAttribute('width', size); bg.setAttribute('height', size); bg.setAttribute('fill', '#fff');
    var p = D.createElementNS(NS, 'path');
    p.setAttribute('d', d); p.setAttribute('fill', '#0B0B0D');
    svg.appendChild(bg); svg.appendChild(p);
    return svg;
  }

  var STATUS = {
    valido: { cls: 'is-ok', txt: 'Pago confirmado · acceso válido' },
    pendiente: { cls: 'is-wait', txt: 'Pago pendiente', note: 'Si pagaste en efectivo, tu acceso se activa cuando se acredite el pago.' },
    cancelado: { cls: 'is-bad', txt: 'Acceso cancelado', note: 'Escríbenos por WhatsApp si crees que es un error.' }
  };

  function checkStatus(entry, card) {
    var badge = $('.ux-pass__status', card);
    var note = $('.ux-pass__note', card);
    if (!window.fetch) { badge.textContent = 'Se valida en la entrada'; return; }
    /* Si la línea con este código sigue en el carrito, la compra NO se terminó (volvió del
       checkout sin pagar): se dice claro y se ofrece retomar el pago, sin consultar al escáner.
       Antes la tarjeta mostraba el QR igual que una compra pagada. */
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || []).some(function (it) {
          return it.properties && normCode(it.properties['Código de acceso']) === entry.code;
        });
      })
      .catch(function () { return false; })
      .then(function (inCart) {
        if (!inCart) { checkScanner(entry, card, badge, note); return; }
        badge.className = 'ux-pass__status is-bad';
        badge.textContent = 'Compra sin terminar';
        note.textContent = 'Tu lugar está en el carrito, pero el pago no se completó. ';
        var a = el('a', 'ux-pass__resume', 'Continuar al pago →');
        a.href = '/checkout';
        note.appendChild(a);
        /* Sin pago no hay pase que descargar: el QR se atenúa y el botón se oculta. */
        var dlBtn = $('.ux-pass__actions .ux-btn--grad', card);
        if (dlBtn) dlBtn.hidden = true;
        var qrBox = $('.ux-pass__qr', card);
        if (qrBox) qrBox.style.opacity = '.25';
      });
  }

  /* Sin escáner (o si no responde) nadie ha verificado el pago: un código tecleado a mano o
     llegado por ?acceso= (ts = 0) no debe verse igual que un boleto recién comprado aquí. */
  function unverified(entry, badge, note) {
    badge.className = 'ux-pass__status';
    badge.textContent = entry.ts ? 'Se valida en la entrada' : 'Sin verificar · se valida en la entrada';
    if (!entry.ts) note.textContent = 'Aún no podemos confirmar el pago desde aquí. Revisa que el código sea el de tu correo de compra y llévalo el día del evento.';
  }

  function checkScanner(entry, card, badge, note) {
    if (!ACCESS_BASE) { unverified(entry, badge, note); return; }
    var ctrl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 7000);
    fetch(ACCESS_BASE + '/api/estado?c=' + encodeURIComponent(entry.code), { mode: 'cors', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (d) {
        clearTimeout(t);
        var st = STATUS[d && d.estado];
        if (st) {
          badge.className = 'ux-pass__status ' + st.cls;
          badge.textContent = st.txt;
          if (st.note) note.textContent = st.note;
          if (d.talla && !entry.talla) { entry.talla = d.talla; fillMeta(entry, card); }
          if (d.nombre && !entry.participante) { var nm = $('.ux-pass__name', card); nm.textContent = d.nombre; nm.hidden = false; }
          return;
        }
        /* no_encontrado: el escáner sincroniza cada ~2 min, así que un pago reciente aún no
           aparece. Nunca se le dice a nadie que compre de nuevo (riesgo de compra doble). */
        var fresh = entry.ts && (Date.now() - entry.ts) < 45 * 60 * 1000;
        if (fresh) {
          badge.className = 'ux-pass__status is-wait';
          badge.textContent = 'Procesando tu compra';
          note.textContent = 'Si ya pagaste, en unos minutos aparece como confirmado.';
        } else if (!entry.ts) {
          /* Código llegado por ?acceso= o tecleado: puede ser de un pago de hace un minuto. */
          badge.className = 'ux-pass__status is-wait';
          badge.textContent = 'Aún no vemos tu pago';
          note.textContent = 'Si acabas de pagar, tarda unos minutos en reflejarse: vuelve a abrir esta página más tarde. Tu código del correo sigue siendo válido. ¿Dudas? WhatsApp 477 390 4522.';
          if (!card.dataset.retry) {
            card.dataset.retry = '1';
            setTimeout(function () { if (card.isConnected) checkScanner(entry, card, badge, note); }, 150000);
          }
        } else {
          badge.className = 'ux-pass__status is-bad';
          badge.textContent = 'Sin pago registrado';
          note.textContent = 'No encontramos un pago con este código. Si ya pagaste, escríbenos por WhatsApp al 477 390 4522 antes de comprar otra vez.';
        }
      })
      .catch(function () {
        clearTimeout(t);
        unverified(entry, badge, note);
      });
  }

  function fillMeta(entry, card) {
    var meta = $('.ux-pass__meta', card);
    meta.textContent = (entry.talla ? 'Jersey talla ' + entry.talla + ' · ' : '') + EVENT_LINE;
  }

  function passCard(entry) {
    var card = el('article', 'ux-pass');
    card.setAttribute('data-code', entry.code);
    var qrBox = el('div', 'ux-pass__qr is-loading');
    qrBox.setAttribute('role', 'img');
    qrBox.setAttribute('aria-label', 'Código QR de tu acceso ' + entry.code);

    var info = el('div', 'ux-pass__info');
    var logo = el('img', 'ux-pass__logo');
    logo.src = root.getAttribute('data-logo-src');
    logo.alt = 'UnoKeeper Ultra 2026';
    logo.width = 688; logo.height = 181;
    var code = el('span', 'ux-pass__code', entry.code);
    var name = el('span', 'ux-pass__name', entry.participante || '');
    name.hidden = !entry.participante;
    var meta = el('span', 'ux-pass__meta');
    var venue = el('span', 'ux-pass__meta', VENUE_LINE);
    var badge = el('span', 'ux-pass__status', 'Verificando…');
    var actions = el('div', 'ux-pass__actions');
    var dl = el('button', 'ux-btn ux-btn--grad');
    dl.type = 'button';
    dl.appendChild(el('span', '', 'Descargar imagen'));
    var rm = el('button', 'ux-btn ux-btn--ghost');
    rm.type = 'button';
    rm.appendChild(el('span', '', 'Quitar'));
    actions.appendChild(dl); actions.appendChild(rm);
    var note = el('p', 'ux-pass__note', 'Descarga la imagen o toma captura para tenerla a la mano sin señal. Tu acceso vale con el pago confirmado: lleva también tu correo de compra.');

    [logo, code, name, meta, venue, badge, actions, note].forEach(function (n) { info.appendChild(n); });
    card.appendChild(qrBox); card.appendChild(info);
    fillMeta(entry, card);

    loadQR().then(function (lib) {
      var qr = qrMatrix(lib, accessUrl(entry.code));
      qrBox.classList.remove('is-loading');
      qrBox.appendChild(qrSvg(qr));
      dl.addEventListener('click', function () { downloadPass(entry, qr); });
    }).catch(function () {
      qrBox.classList.remove('is-loading');
      qrBox.appendChild(el('p', 'ux-pass__note', 'No se pudo dibujar el QR. Muestra tu código en la entrada: ' + entry.code));
      dl.hidden = true;
    });

    rm.addEventListener('click', function () {
      if (!window.confirm('¿Quitar este acceso de este dispositivo? Tu compra no se cancela.')) return;
      store.remove(entry.code);
      card.remove();
    });

    checkStatus(entry, card);
    return card;
  }

  function downloadPass(entry, qr) {
    var W = 900, H = 1240;
    var cv = D.createElement('canvas');
    cv.width = W; cv.height = H;
    var g = cv.getContext('2d');
    var grad = g.createLinearGradient(0, 0, W, H);
    grad.addColorStop(0, '#2A0540'); grad.addColorStop(.55, '#0B0B0D'); grad.addColorStop(1, '#3A0A24');
    g.fillStyle = grad; g.fillRect(0, 0, W, H);
    var band = g.createLinearGradient(0, 0, W, 0);
    band.addColorStop(0, '#8402BE'); band.addColorStop(.3, '#AB04D8'); band.addColorStop(.65, '#F24098'); band.addColorStop(1, '#FD930C');
    g.fillStyle = band; g.fillRect(0, H - 18, W, 18);

    var finish = function (logoImg) {
      if (logoImg) g.drawImage(logoImg, (W - 520) / 2, 60, 520, 520 * 181 / 688);
      else { g.fillStyle = '#fff'; g.font = '900 italic 64px Montserrat, Arial, sans-serif'; g.textAlign = 'center'; g.fillText('UNOKEEPER ULTRA', W / 2, 150); }
      g.textAlign = 'center';
      g.fillStyle = 'rgba(247,245,250,.8)';
      g.font = '600 22px Montserrat, Arial, sans-serif';
      g.fillText('A C C E S O   ·   7 ª   E D I C I Ó N', W / 2, 252);

      var box = 560, bx = (W - box) / 2, by = 290;
      g.fillStyle = '#fff';
      if (g.roundRect) { g.beginPath(); g.roundRect(bx, by, box, box, 28); g.fill(); } else g.fillRect(bx, by, box, box);
      var n = qr.getModuleCount(), cell = Math.floor((box - 64) / n), off = bx + (box - cell * n) / 2, offY = by + (box - cell * n) / 2;
      g.fillStyle = '#0B0B0D';
      for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) if (qr.isDark(r, c)) g.fillRect(off + c * cell, offY + r * cell, cell, cell);

      g.fillStyle = '#fff';
      g.font = '700 46px ui-monospace, Menlo, Consolas, monospace';
      g.fillText(entry.code, W / 2, 935);
      if (entry.participante) { g.font = '700 34px Montserrat, Arial, sans-serif'; g.fillText(entry.participante.slice(0, 40), W / 2, 1000); }
      g.fillStyle = 'rgba(247,245,250,.78)';
      g.font = '500 28px Montserrat, Arial, sans-serif';
      g.fillText((entry.talla ? 'Jersey talla ' + entry.talla + '  ·  ' : '') + EVENT_LINE, W / 2, 1058);
      g.fillText(VENUE_LINE, W / 2, 1102);
      g.fillStyle = '#FD930C';
      g.font = '700 22px Montserrat, Arial, sans-serif';
      g.fillText('Muéstralo en la entrada para darte de alta', W / 2, 1168);

      try {
        var a = D.createElement('a');
        a.download = 'acceso-ultra-2026-' + entry.code + '.png';
        a.href = cv.toDataURL('image/png');
        D.body.appendChild(a); a.click(); a.remove();
      } catch (e) {
        window.alert('Tu navegador no permitió descargar la imagen. Toma una captura de pantalla de tu acceso.');
      }
    };

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { finish(img); };
    img.onerror = function () { finish(null); };
    img.src = root.getAttribute('data-logo-src');
  }

  function initAccess() {
    var list = $('[data-access-list]');
    var find = $('[data-access-find]');
    if (!list) return;

    var fromLink = null;
    try { fromLink = normCode(new URLSearchParams(window.location.search).get('acceso')); } catch (e) { /* sin URLSearchParams */ }
    if (fromLink && !store.get().some(function (a) { return a.code === fromLink; })) {
      store.upsert({ code: fromLink, ts: 0 });
    }

    function render() {
      list.textContent = '';
      store.get().slice().reverse().forEach(function (entry) { list.appendChild(passCard(entry)); });
    }
    render();

    if (fromLink) {
      window.addEventListener('load', function () {
        var sec = D.getElementById('acceso');
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (find) {
      var input = $('input', find);
      var err = $('[data-access-err]', find);
      find.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var code = normCode(input.value);
        if (!code) { err.textContent = 'Revisa el código: tiene la forma UK26-XXXX-XXXX.'; input.focus(); return; }
        err.textContent = '';
        var known = store.get().filter(function (a) { return a.code === code; })[0];
        store.upsert(known || { code: code, ts: 0 });
        render();
        input.value = '';
        var card = list.querySelector('[data-code="' + code + '"]');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function boot() {
    [initChrome, initClock, initHeroVideo, initVideos, initCarousel, initBuy, initCartNotice, initAccess].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('[ultra]', fn.name, e); }
    });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
